/* eslint import/no-extraneous-dependencies: off */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const setThemeLinking = createAsyncThunk(
  "themeLinking/setThemeLinking",
  async (themeLinking) => {
    return themeLinking;
  }
);

const initialState = {
  operation_profile_id: "",
  theme_profile_id: "",
  theme_profile_link_id: "",
  status: "active",
};

const themeLinkingSlice = createSlice({
  name: "themeLinking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setThemeLinking.fulfilled,
      (state, action) => action.payload
    );
  },
});

export const selectThemeLinking = ({ themeLinking }) => themeLinking;

export default themeLinkingSlice.reducer;
